import styled from 'styled-components'

export const CopyrightIcon = styled.span`
  display: inline-block;
  max-height: 0.625rem;
  line-height: 2.25rem;
  font-size: 2.125rem;
  padding-right: 0.188rem;
  vertical-align: top;
`

export const HelpContainer = styled.div`
  padding-top: 8.875rem;

  @media only screen and (max-width: 600px) {
    padding-top: 3.875rem;
  }
`

export const HelpMessage = styled.p`
  font-family: 'Molde-Medium';
  margin-bottom: 0.5rem;
`

export const HelpList = styled.ul`
  font-family: 'Molde-Regular';
  margin-top: 0.5rem;
  padding-left: 0.625rem;
`

export const HelpListItem = styled.li`
  font-size: 0.75rem;
`

export const HelpText = styled.span`
  font-size: 1rem;
`

export const ErrorPage = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: 'Molde-regular';
  background-color: #eef0f2;
  height: 100%;
  overflow: auto;

  @media only screen and (max-width: 600px) {
    justify-content: flex-start;
  }
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 37.5rem;
  padding: 1.25rem;
  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 6px;
  color: #555555;
  margin: 10rem 1rem 2.25rem;

  @media only screen and (max-width: 600px) {
    margin-top: 8.5rem;
  }
`

export const UnableToAuthenticateContainer = styled(ErrorContainer)`
  background-color: #eef0f2;
  margin: 0;
  max-width: 100%;

  @media only screen and (max-width: 600px) {
    margin-top: 4.625rem;
    padding: 1.25rem 0 1.25rem;
  }
`

export const ErrorDetail = styled.span`
  color: #002855;
  display: flex;
  align-self: center;
  font-family: 'Molde-Medium';
  font-size: 1.125rem;
  padding: 2rem 0 1.313rem;
`

export const ErrorHeader = styled.h2`
  color: #002855;
  font-family: 'SharpSlab-Semibold';
  font-size: 1.438rem;
  margin: 0.938rem 0 0.438rem;
`

export const ErrorMessage = styled.div`
  background-color: #eef0f2;
  border-radius: 5px;
  color: #555555;
  display: flex;
  flex-direction: column;
  font-family: 'Molde-Regular';
  padding: 0.875rem 1rem;
`

export const Footer = styled.footer`
  display: flex;
  align-self: normal;
  justify-content: space-between;
  margin-top: auto;
  margin-bottom: 2.5rem;
  padding: 0 1.25rem;

  @media only screen and (max-width: 600px) {
    flex-direction: column-reverse;
    text-align: center;
  }
`

export const FooterLink = styled.a`
  color: inherit;
  font-size: 0.75rem;
  padding: 0 0.3rem;
  text-decoration: none;

  &:first-of-type {
    padding-left: 0;
  }

  &:hover,
  &:visited {
    color: inherit;
  }
`

export const FooterLogo = styled.img`
  height: 2.938rem;

  @media only screen and (max-width: 600px) {
    margin-bottom: 1.125rem;
  }
`

export const FooterTerms = styled.div`
  font-size: 0.75rem;
  color: #25282a;
`

export const FooterText = styled.p`
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 0.2rem;
  }

  @media only screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;

    span:not(:last-child) {
      margin-bottom: 0.2rem;
    }
  }
`

export const FooterLinks = styled.p`
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 0.2rem;
  }
`

export const LogoutLink = styled.button`
  align-self: start;
  background: none;
  border: none;
  color: #205c96;
  cursor: pointer;
  font-family: 'Molde-Medium';
  font-size: 1rem;
  margin: 1rem 0;
  padding: 0;

  :hover {
    text-decoration: underline;
  }
`

export const Hr = styled.hr`
  border: 1px solid #eef0f2;
  border-radius: 0.75px;
  margin-bottom: 1.25rem;
  margin-top: 0.375rem;
  width: 100%;
`

export const SecondStepLogo = styled.img`
  width: 5.188rem;

  @media only screen and (max-width: 600px) {
    width: 6.25rem;
  }
`

export const SecondStepLogoLink = styled.a`
  position: absolute;
  top: 20px;
  left: 20px;

  @media only screen and (max-width: 600px) {
    top: 40px;
    left: unset;
  }
`
